// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-user-set-password .mat-mdc-form-field-icon-suffix {
  padding-right: 5px;
}
.fi-user-set-password .mat-mdc-form-field-icon-suffix .password-icon {
  color: var(--fi-color-grey);
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/set-password/set-password.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAEQ;EACI,2BAAA;EACA,eAAA;AAAZ","sourcesContent":[".fi-user-set-password {\r\n    .mat-mdc-form-field-icon-suffix {\r\n        padding-right: 5px;\r\n\r\n        .password-icon {\r\n            color: var(--fi-color-grey);\r\n            font-size: 18px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
